import React from "react";
import { NAV } from "@/components/layout/AppShell";
import { useLocation } from "react-router-dom";
import { SectionCard } from "@/components/tmo/primitives";
import { Hammer } from "lucide-react";

const PLANNED = {
  "/applications": ["Filterable inventory table with 8+ dropdowns", "Card / Heat Map / Dependency views", "Per-app score decomposition detail page", "XLSX / CSV export with filter header"],
  "/testing": ["Testing Health Index & coverage by stream", "Evidence-type badges (Tool / Manual / Vendor / Inherited)", "Environment constraint flags", "Defects trend & automation coverage"],
  "/dependencies": ["Three-layer React Flow dependency map", "Upstream / downstream traversal + hops slider", "Single points of failure ranked by blast radius", "Needs-Mapping panel for unresolved strings"],
  "/issues": ["Severity KPI row + 3×3 risk heat map", "Inherent score = Impact × Likelihood", "Issues by stream and category", "CRUD register to replace seed data"],
  "/reports": ["Report catalog with end-user grouping", "Branded PDF / XLSX generation", "Scheduling (weekly / monthly / quarterly)", "Request Report workflow"],
  "/admin": ["Readiness Models weight editor with live preview", "Users, roles & data sources", "Ingest manifest, promote & rollback", "Audit trail export"],
};

export default function Stub() {
  const location = useLocation();
  const nav = NAV.find((n) => n.to === location.pathname) || NAV[0];
  const planned = PLANNED[location.pathname] || [];
  return (
    <div className="max-w-3xl" data-testid="stub-page">
      <SectionCard title={nav.label} subtitle="Planned for the next build phase">
        <div className="flex items-start gap-3 mb-4 p-3 rounded-lg bg-cnp-bg">
          <Hammer className="text-cnp-amber shrink-0" size={20} />
          <p className="text-sm text-cnp-text">
            This screen is scaffolded and wired to the scenario selector and the scoring engine.
            The four core screens — Overview and the three stream views — are fully built and live.
            Below is what lands here next.
          </p>
        </div>
        <ul className="space-y-2">
          {planned.map((p, i) => (
            <li key={i} className="flex items-start gap-2 text-sm text-cnp-text">
              <span className="h-5 w-5 rounded-full bg-cnp-blue/10 text-cnp-blue text-[11px] font-bold flex items-center justify-center shrink-0 mt-0.5">{i + 1}</span>
              {p}
            </li>
          ))}
        </ul>
      </SectionCard>
    </div>
  );
}
